var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 142,
    viewBox: "0 0 149 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M107.249 79.415L2.32031 23.2191L108.402 126.447L107.249 79.415Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_2",
    d: "M137.239 53.2555L2.32031 23.2191L107.249 79.415L137.239 53.2555Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_3",
    d: "M107.777 126.009L76.1953 105.763L89.286 93.2575C90.4715 92.125 92.4197 92.4982 93.1027 93.9886L107.777 126.009Z",
    fill: "#D6E4FF",
    stroke: "black",
    strokeWidth: 2.38571
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.1279 128.132L1.69531 22.7807L91.2687 91.5707L52.1279 128.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.15948883741d87e374ff9d302dd286df.svg";
export { ForwardRef as ReactComponent };